/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Website API
 * The backend API for the website SPA
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  AccountId,
  HttpValidationProblemDetails,
  MoveRegistrationCompositeRequest,
  RegistrationCompositeDetailsResponse,
  RegistrationCompositeId,
  SegmentationId
} from './data.schemas'




export const getRegistrationComposite = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<RegistrationCompositeDetailsResponse>> => {
    
    return axios.default.get(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}`,options
    );
  }


export const getGetRegistrationCompositeQueryKey = (segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,) => {
    return [`/api/segment/${segmentationId}/customers/${accountId}/registrationComposites/${registrationCompositeId}`] as const;
    }

    
export const getGetRegistrationCompositeQueryOptions = <TData = Awaited<ReturnType<typeof getRegistrationComposite>>, TError = AxiosError<string>>(segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationComposite>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRegistrationCompositeQueryKey(segmentationId,accountId,registrationCompositeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistrationComposite>>> = ({ signal }) => getRegistrationComposite(segmentationId,accountId,registrationCompositeId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(segmentationId && accountId && registrationCompositeId),  staleTime: 900000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRegistrationComposite>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRegistrationCompositeQueryResult = NonNullable<Awaited<ReturnType<typeof getRegistrationComposite>>>
export type GetRegistrationCompositeQueryError = AxiosError<string>

export const useGetRegistrationComposite = <TData = Awaited<ReturnType<typeof getRegistrationComposite>>, TError = AxiosError<string>>(
 segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationComposite>>, TError, TData>>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRegistrationCompositeQueryOptions(segmentationId,accountId,registrationCompositeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

export const prefetchGetRegistrationComposite = async <TData = Awaited<ReturnType<typeof getRegistrationComposite>>, TError = AxiosError<string>>(
 queryClient: QueryClient, segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRegistrationComposite>>, TError, TData>>, axios?: AxiosRequestConfig}

  ): Promise<QueryClient> => {

  const queryOptions = getGetRegistrationCompositeQueryOptions(segmentationId,accountId,registrationCompositeId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}


export const deleteRegistrationComposite = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.delete(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}`,options
    );
  }



export const getDeleteRegistrationCompositeMutationOptions = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistrationComposite>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRegistrationComposite>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRegistrationComposite>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId} = props ?? {};

          return  deleteRegistrationComposite(segmentationId,accountId,registrationCompositeId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRegistrationCompositeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRegistrationComposite>>>
    
    export type DeleteRegistrationCompositeMutationError = AxiosError<string>

    export const useDeleteRegistrationComposite = <TError = AxiosError<string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRegistrationComposite>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteRegistrationComposite>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId},
        TContext
      > => {

      const mutationOptions = getDeleteRegistrationCompositeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const moveRegistrationComposite = (
    segmentationId: SegmentationId,
    accountId: AccountId,
    registrationCompositeId: RegistrationCompositeId,
    moveRegistrationCompositeRequest: MoveRegistrationCompositeRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    return axios.default.post(
      `/api/segment/${encodeURIComponent(String(segmentationId))}/customers/${encodeURIComponent(String(accountId))}/registrationComposites/${encodeURIComponent(String(registrationCompositeId))}/move`,
      moveRegistrationCompositeRequest,options
    );
  }



export const getMoveRegistrationCompositeMutationOptions = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveRegistrationComposite>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: MoveRegistrationCompositeRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof moveRegistrationComposite>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: MoveRegistrationCompositeRequest}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveRegistrationComposite>>, {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: MoveRegistrationCompositeRequest}> = (props) => {
          const {segmentationId,accountId,registrationCompositeId,data} = props ?? {};

          return  moveRegistrationComposite(segmentationId,accountId,registrationCompositeId,data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MoveRegistrationCompositeMutationResult = NonNullable<Awaited<ReturnType<typeof moveRegistrationComposite>>>
    export type MoveRegistrationCompositeMutationBody = MoveRegistrationCompositeRequest
    export type MoveRegistrationCompositeMutationError = AxiosError<HttpValidationProblemDetails | string>

    export const useMoveRegistrationComposite = <TError = AxiosError<HttpValidationProblemDetails | string>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveRegistrationComposite>>, TError,{segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: MoveRegistrationCompositeRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof moveRegistrationComposite>>,
        TError,
        {segmentationId: SegmentationId;accountId: AccountId;registrationCompositeId: RegistrationCompositeId;data: MoveRegistrationCompositeRequest},
        TContext
      > => {

      const mutationOptions = getMoveRegistrationCompositeMutationOptions(options);

      return useMutation(mutationOptions);
    }
    